var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStewardOuter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 161,
    viewBox: "0 0 162 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.6426,
    cy: 80.5,
    r: 77.5,
    fill: "#44546A",
    stroke: "#44546A",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStewardOuter);
export default __webpack_public_path__ + "static/media/StewardOuter.79d9d5e186d6a8537369847b43206b42.svg";
export { ForwardRef as ReactComponent };